import React from "react";

import { Button, Typography } from "@material-ui/core";

import SvgI24Archive from "assets/icons/I24Archive";
import SvgI24Edit from "assets/icons/I24Edit";

import TrimmedText from "components/TrimmedText";

import {
  Container,
  ImageContainer,
  DetailsContainer,
  TextContainer,
  TitleWrapper,
  ControlsContainer,
  ControlWrapper,
} from "./styles";

type Props = {
  title: string;
  duration: string;
  image: string;
  details?: any;
  onEdit: () => void;
  onArchive: () => void;
};

class MovementCard extends React.Component<Props> {
  render() {
    const { title, duration, image, onEdit, onArchive } = this.props;

    return (
      <Container>
        <ImageContainer image={image} />
        <DetailsContainer>
          <TextContainer>
            <TitleWrapper>
              <TrimmedText lines={1} text={title}>
                <Typography variant="h3" color="textPrimary">
                  {title}
                </Typography>
              </TrimmedText>
            </TitleWrapper>
            <Typography variant="subtitle1" color="secondary">
              {duration}
            </Typography>
          </TextContainer>
        </DetailsContainer>
        <ControlsContainer>
          <ControlWrapper>
            <Button
              startIcon={<SvgI24Edit />}
              variant="text"
              color="secondary"
              onClick={onEdit}
            >
              Edit
            </Button>
          </ControlWrapper>
          <ControlWrapper>
            <Button
              startIcon={<SvgI24Archive />}
              variant="text"
              color="secondary"
              onClick={onArchive}
            >
              Archive
            </Button>
          </ControlWrapper>
        </ControlsContainer>
      </Container>
    );
  }
}

export default MovementCard;
